export * from "./minMaxReducer.pure";

import "../Shaders/minmaxRedux.fragment";
import "../ShadersWGSL/minmaxRedux.fragment";
